import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ThemeProvider, createTheme } from '@mui/material';

const theme = createTheme({
  palette: {
    primary: {
      light: "#435A75",
      main: "#15212f",
      dark: "rgba(47, 47, 47, 0.2) ",
      contrastText: "#fff",
    },
    secondary: {
      light: "#E5D6C1",
      main: "#af8c55",
      dark: "#E5D6C1",
      contrastText: "#fff",
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <ThemeProvider theme={theme}>
    <App />
  </ThemeProvider>
);

